import TrialApplyStartButton from '@components/app/TrialApply/TrialApplyStartButton.client'
import { Icon } from '@components/primitives/Icon'
import Link from '@components/primitives/Link'
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock'
import Routes from '@lib/routes'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import { type getClinicalTrialForGetStartedPage } from '@modules/trials/helpers/fragments/clinicalTrialGetStartedFragment'
import { useLongPress } from '@uidotdev/usehooks'

const TermsOfServiceText = () => {
  const longPressPropsForTermsOfService = useLongPress(
    () => window.open(absoluteUrl(Routes.termsOfService)),
    { threshold: 500 },
  )
  const longPressPropsForPrivacyPolicy = useLongPress(
    () => window.open(absoluteUrl(Routes.privacyPolicy)),
    { threshold: 500 },
  )

  return (
    <span className='text-sm font-medium text-neutral500'>
      By clicking start, you agree to our{' '}
      <Link
        className='hidden md:inline'
        href={absoluteUrl(Routes.termsOfService)}
        newTab
      >
        Terms of Service
      </Link>
      <span className='md:hidden' {...longPressPropsForTermsOfService}>
        Terms of Service
      </span>{' '}
      and{' '}
      <Link
        className='hidden md:inline'
        href={absoluteUrl(Routes.privacyPolicy)}
        newTab
      >
        Privacy Policy
      </Link>
      <span className='md:hidden' {...longPressPropsForPrivacyPolicy}>
        Privacy Policy
      </span>
    </span>
  )
}

const StartPageFooter = ({
  trial,
}: {
  trial: Awaited<ReturnType<typeof getClinicalTrialForGetStartedPage>>
}) => {
  return (
    <div className='fixed bottom-0 w-full bg-white px-6 pb-4 shadow-[0_-2px_4px_rgba(0,0,0,0.1)] md:w-[80%] md:px-0 md:pb-8 md:shadow-none'>
      <div className='flex w-full flex-col items-center justify-between md:flex-row'>
        <div className='mb-4 mt-2 max-w-full flex-1 md:mb-0 md:max-w-[40%]'>
          <TermsOfServiceText />
        </div>
        <div className='flex w-full flex-1 items-center justify-end gap-8'>
          <span className='hidden text-sm font-medium text-neutral500 md:block'>
            <Icon icon={faClock} /> 3m application
          </span>
          <TrialApplyStartButton slug={trial.slug!} />
        </div>
      </div>
    </div>
  )
}

export default StartPageFooter
